import { Injectable, Injector, OnDestroy } from '@angular/core';
import { Data, Router } from '@angular/router';
import { AuthService } from '@core/auth.service';
import { getAuth } from 'firebase/auth';
import { catchError, combineLatest, map, Observable, of, Subject, switchMap, take } from 'rxjs';
import { CommonVariable } from 'src/app/app.constants';
import { v4 as uuidv4 } from "uuid";
import { CommonService } from '../../common/common.service';
import { SalesJourneyIdentityService } from '../../sales-journey-identity.service';
import {
  buildCreditJoinContextKey,
  ensureJoinIdempotencyKey,
  getBrowserSessionStorage,
} from '../../syndicate-join-idempotency';

@Injectable({
  providedIn: 'root'
})
export class RequestPaymentService implements OnDestroy {
  private destroy$ = new Subject<void>();
  customerId: string;
  preferredCurrency: string;
  public checkApiPostReqProfileImg;
  public checkApiPostReqRemovePhoto;
  constructor(
    private router: Router,
    private injector: Injector,
    private authService: AuthService,
    private commmonService: CommonService,
    private salesJourneyIdentityService: SalesJourneyIdentityService
  ) {
    this.checkApiPostReqProfileImg = false;
    this.checkApiPostReqRemovePhoto = false;
    this.preferredCurrency = "GBP";
    this.authService.getUid$("RequestPaymentService").pipe(
      switchMap(userId => {
        if (!userId) {
          return of(null); // or EMPTY if you want no emission
        }
        this.customerId = userId;
        return of(userId);
      })
    );
  }
  // This function is used to get the request body for to validate request is validate or not
  private validateRequest(): boolean {
    return true;
  }

  // This function is used to get the request body for insert purchase request  [this function is not call anywhere so comment it ]
  public insertPaymentPurchaseRequest(offerId, amount) {
    if (this.validateRequest()) {
      return {
        modules: [
          {
            session_ID: "CommonService.session.session_id",
            page_ID: "4",
            screen_id: "4.12",
            website: "Lotto Social",
            website_id: "33",
            source_site: "mobi.lottosocial.com",
            customer_id: this.customerId,
            offer_id: offerId,
            prosub_id: null,
            tp1: "",
            tp2: "",
            tp3: "",
            t_id: "",
            other: null,
            value: amount,
            p_type: "10",
            action: "insert_customer_purchase",
            module_name: "insert_customer_purchase",
          },
        ],
      };
    }
  }

  // This function is used to get the request body for process paymil card payment
  getPaymentReqResRequest(paymentReq: any, paymentRes: any, isPreAuth?: any) {
    console.log("the paymentReq", paymentReq);
    let userId = null;
    this.authService.getUid$("RequestPaymentService").pipe(
      switchMap((uid) => {
        userId = uid;
        return of(userId) || of(null);
      }));
    //remaining
    /* const authService = this.injector.get(AuthService);
    authService.userDetails$.pipe(take(1)).subscribe((user: any) => {
      this.preferredCurrency = user?.preferred_currency ? user?.preferred_currency : "GBP";
    });*/
    const req = {
      modules: [
        {
          module_name: "paymill_card_payment_processing_mobile_app",
          request: paymentReq,
          response: paymentRes,
          user_Id: userId,
          customer_purchase_id:
            paymentReq?.customer_purchase?.customer_purchase_id ||
            paymentReq?.response?.customer_purchase_id ||
            paymentReq.customer_purchase_id,
          session_id: paymentRes?.timestamp,
        },
      ],
    };

    if (isPreAuth) {
      req.modules[0]["sub_status"] = "pre_auth";
    }

    return req;
  }

  // This function is used to get the request body for payment status API cia sql
  getPaymentStatusViaSQLRequest(ndc: string) {
    let userId = null;
    this.authService.getUid$("RequestPaymentService").pipe(
      switchMap((userId) => {
        userId = userId;
        return of(userId) || of(null);
      }));
    const req = {
      modules: [
        {
          module_name: "payment_malformed_correction_request",
          user_id: userId,
          ndc: ndc,
        },
      ],
    };

    return req;
  }

  getPaymentReqResRequestNew(paymentReq: Data, paymentRes: Data, cp_Request: Data, ndc: string, isPreAuth?: boolean) {
    //remaining
    let userId = null;
    this.authService.getUid$("RequestPaymentService").pipe(
      switchMap((userId) => {
        userId = userId;
        return of(userId) || of(null);
      }));
    const authService = this.injector.get(AuthService);
    authService.userDetails$.pipe(take(1)).subscribe((user) => {
      this.preferredCurrency = user?.preferred_currency ? user?.preferred_currency : "GBP";
    });

    if (cp_Request && cp_Request.T_ID !== undefined && cp_Request.T_ID === "null") {
      cp_Request.T_ID = "";
    }

    const req = {
      modules: [
        {
          module_name: "paymill_card_payment_processing_mobile_app_async",
          request: paymentReq,
          response: paymentRes,
          user_Id: userId,
          customer_purchase_id: paymentReq?.customer_purchase?.customer_purchase_id
            ? paymentReq?.customer_purchase?.customer_purchase_id
            : paymentReq.customer_purchase_id,
          session_id: paymentRes?.timestamp,
          ndc: ndc,
          ...cp_Request,
        },
      ],
    };

    if (isPreAuth) {
      req.modules[0]["sub_status"] = "pre_auth";
    }

    return req;
  }

  // This function is used to get the request body for get paymil card details using offer id and order id  [this function is not call anywhere so comment it ]
  getCardDetails(offerId, orderId?) {
    const paymilDetails = {
      session_ID: "CommonService.session.session_id",
      page_ID: "4",
      screen_id: "4.10",
      action: "get_card_details",
      website: "Lotto Social",
      website_id: "33",
      source_site: "mobi.lottosocial.com",
      module_name: "get_customer_paymill_card_details",
      customer_id: this.customerId,
      p_type: "10",
    };
    if (orderId) {
      return { ...paymilDetails, ...{ private_syndicate_id: offerId } };
    }
    return { ...paymilDetails, ...{ paymill_offer_id: offerId } };
  }


  // This function is used to get the request body for get customer details
  public getUserAndCardDetailsRequests(offerId, orderId?) {
    if (this.validateRequest()) {
      return {
        modules: [
          this.getCardDetails(offerId, orderId),
          {
            session_ID: "CommonService.session.session_id",
            page_ID: "7",
            screen_id: "7.2",
            action: "profile_details",
            website: "Lotto Social",
            website_id: "33",
            source_site: "mobi.lottosocial.com",
            module_name: "get_customer_details",
            customer_id: this.customerId,
          },
        ],
      };
    }
  }
  // This function is used to get the request body for process paymil card payment
  public getPayMilFinalPaymentRequest(offerDetails, customerDetails, cardDetails, purchaseID) {
    if (this.validateRequest()) {
      return {
        modules: [
          {
            session_ID: "CommonService.session.session_id",
            page_ID: "4",
            screen_id: "4.11",
            action: "process_paymill_card_payment",
            website: "Lotto Social",
            website_id: "33",
            source_site: "mobi.lottosocial.com",
            module_name: "process_paymill_card_payment",
            customer_id: this.customerId,
            title: customerDetails?.title,
            first_name: customerDetails.first_name,
            last_name: customerDetails.last_name,
            dob: customerDetails.dob,
            phone: customerDetails.mobile_number,
            mobile: customerDetails.mobile_number,
            email: customerDetails.email_address,
            amount: offerDetails.total_cost,
            customer_web_lead_id: "",
            TP1: "",
            TP2: "",
            TP3: "",
            T_ID: "",
            customeR_purchase_id: purchaseID,
            p_type: "10",
            offer_id: offerDetails?.offer_id,
            status: "",
            prosub_id: offerDetails?.prosub_id,
            payment_currency: "GBP",
            payment_type: "payment",
            award_id: "",
            transaction_log_id: "",
            customer_payment_stored_detail_id: cardDetails.pay_stored_detail_id,
            client_id: cardDetails.client_id,
            client_pay_id: cardDetails.client_pay_id,
            voucher_code_id: offerDetails.voucher_code_id,
          },
        ],
      };
    }
  }

  // This function is used to get the request body for buy credit offer
  public getCreditPaymentRequest(offerId) {
    if (this.validateRequest()) {
      // Use customerId (set by constructor uid subscription) — never mint a fresh UUID per call.
      // Align with doCreditPayment via buildCreditJoinContextKey + ensureJoinIdempotencyKey.
      const storage = getBrowserSessionStorage();
      const userId = this.customerId || "anon";
      const contextKey = buildCreditJoinContextKey(userId, { offerid: offerId });
      const idempotencyKey = ensureJoinIdempotencyKey(storage, contextKey);
      return {
        modules: [
          {
            website: "Lotto Social",
            website_id: "27",
            module_name: "buy_credit_offer",
            user_id: this.customerId,
            offer_id: offerId,
            visitor_id: null,
            requestid: idempotencyKey,
            idempotency_key: idempotencyKey,
          },
        ],
      };
    }
  }


  // This function is used to get the request body for get user specific offers for the lottery product  [this function is not call anywhere so comment it ]
  public getProductPageRequest(productName) {
    if (this.validateRequest()) {
      return {
        request: [
          {
            page_id: "2",
            screen_id: "2.3.1",
            module_name: "get_offers_for_you",
            customer_id: this.customerId,
            product_name: productName,
          },
        ],
      };
    }
  }
  // This function is used to get the request body for get ticket details for success page
  public getTicketDetailsWithPurchaseIdRequest(purchaseID) {
    if (this.validateRequest()) {
      return {
        request: [
          {
            module_name: "get_success_page_details",
            customer_id: this.customerId,
            customer_purchase_id: purchaseID,
          },
        ],
      };
    }
  }
  // This function is used to get the request body for convert credit to cash
  getCreditToConversion(claimEventId: string) {
    if (!this.validateRequest()) return of(null);

    return this.commmonService.getUid("").pipe(
      map((uid) => {
        return {
          modules: [
            {
              module_name: "swap_credit_to_cash",
              user_id: uid,
              claim_event_id: claimEventId,
              requestid: uuidv4(),
              document: "/api_post_request/swap_credit_to_cash",
            },
          ],
        };
      })
    );
  }

  // This function is used to get the request body for to update credit cash
  updateCreditCashOut(cashOutAmount: any) {
    return this.commmonService.getUid("").pipe(map((res) => {
      if (this.validateRequest()) {
        return {
          modules: [
            {
              module_name: "updatecashclaim",
              user_id: res,
              cashout_method: "credit",
              cashout_amount: cashOutAmount,
              requestid: uuidv4(),
              document: "/api_post_request/update_credit_cashOut",
            },
          ],
        };
      }
    }))

  }

  // This function is used to get the request body for to update charity cashout
  updateCharityCashOut(cashOutAmount: any) {
    return this.commmonService.getUid("").pipe(map((res) => {
      if (this.validateRequest()) {
        return {
          modules: [
            {
              module_name: "updatecashclaim",
              user_id: res,
              cashout_method: "charity",
              cashout_amount: cashOutAmount,
              requestid: uuidv4(),
              document: "/api_post_request/update_charity_cashOut",
            },
          ],
        };
      }
    }))
  }

  updatePayPalCashOut(cashOutAmount: any, payPalEmail: string) {
    return this.commmonService.getUid("").pipe(map((res) => {
      if (this.validateRequest()) {
        return {
          modules: [
            {
              module_name: "updatecashclaim",
              user_id: res,
              cashout_method: "paypal",
              cashout_amount: cashOutAmount,
              cashout_email: payPalEmail,
              requestid: uuidv4(),
              document: "/api_post_request/update_paypal_cashOut",
            },
          ],
        };
      }
    }));
  }
  // This function is used to get the request body for remove payment method
  removeWalletCard(cardId: string): Observable<any> {
    return this.authService.getUid$("RequestPaymentService").pipe(
      map((userId) => {
        if (!this.validateRequest()) {
          console.error("Remove Wallet Card request validation failed");
          return null;
        }

        return {
          modules: [
            {
              module_name: "remove_payment_method",
              user_id: userId,
              card_id: cardId,
              requestid: uuidv4(),
              document: "/api_post_request/remove_payment_method",
            },
          ],
        };
      })
    );
  }
  // This function is used to get the request body for get MGM details for the User  [this function is not call anywhere so comment it ]
  getMgmDetailsRequest(mgmType) {
    if (this.validateRequest()) {
      return {
        request: [
          {
            page_id: "15",
            screen_id: "15.1",
            action: "get_mgm_details",
            mgm_type: mgmType,
            module_name: "get_refer_friend",
            program_id: "9",
            customer_id: this.customerId,
          },
        ],
      };
    }
  }

  // This function is used to get the request body for get winnings of the user
  getWinning() {
    if (this.validateRequest()) {
      return this.authService.getUid$("RequestPaymentService").pipe(
        map((userId) => {
          return {
            modules: [
              { page_id: "9", module_name: "check_my_winning", user_id: userId, website: "LS App" },
            ],
          };
        }));
    } else {
      return of(null);
    }
  }

  // This function is used to get the request body for convert credit to cash    [this function is not call anywhere so comment it ]
  getCreditToCashRequest(claimEventId) {
    if (this.validateRequest()) {
      return {
        request: [
          {
            session_ID: "CommonService.session.session_id",
            page_ID: "9",
            screen_id: "9.3",
            action: "convert_cash",
            website: "Lotto Social",
            website_id: "33",
            source_site: "mobi.lottosocial.com",
            module_name: "convert_credit_to_cash",
            claim_event_id: claimEventId,
            customer_id: this.customerId,
          },
        ],
      };
    }
  }

  //GDPR / LEGAL API Method
  // This function is used to get the request body for update user's marketing communication preferences.
  public updatePreferencesGDPRRequest(
    smsPref: boolean,
    emailPref: boolean,
    pushPref: boolean
  ): Observable<any> {
    return this.authService.getUid$("RequestPaymentService").pipe(
      map((uid) => {
        if (!this.validateRequest()) {
          console.error("GDPR preferences request validation failed");
          return null;
        }

        this.customerId = uid;

        const campaignIdsRaw = localStorage.getItem('campaign_ids');
        const campaignIds = campaignIdsRaw ? JSON.parse(campaignIdsRaw) : null;
        return {
          modules: [
            {
              module_name: "update_customer_promotional_prefs",
              user_id: this.customerId,
              sms_pref: smsPref,
              email_pref: emailPref,
              push_pref: pushPref,
              website_id: "33",
              calling_method: "db",
              campaign_id: campaignIds
            },
          ],
        };
      })
    );
  }



  // This function is used to get the request body for get customers winning details
  checkWinningReq(): Observable<any> {
    return this.authService.getUid$("RequestPaymentService").pipe(
      map((uid) => {
        return {
          modules: [
            {
              module_name: "get_claimable_syndicate_details",
              user_id: uid,
            },
          ],
        };
      })
    );
  }
  updatePrimaryCard(cardId: string) {
    if (this.validateRequest()) {
      return this.authService.getUid$("RequestPaymentService").pipe(
        map((userId) => {
          return {
            modules: [
              {
                module_name: "update_primary_card",
                user_id: userId,
                card_id: cardId,
                requestid: uuidv4(),
                document: "/api_post_request/update_primary_card",
              },
            ],
          };
        })
      );
    }
  }

  public validatePurchaseProductWithNdc(
    customerPurchaseId: string,
    ndc: string
  ): Observable<any> {
    return combineLatest([
      this.authService.getUid$("RequestPaymentService"),
      this.injector.get(AuthService).userDetails$.pipe(take(1)),
    ]).pipe(
      map(([uid, user]) => {
        const auth = getAuth();

        // Resolve preferred currency
        this.preferredCurrency = user?.preferred_currency
          ? user.preferred_currency
          : CommonVariable.preferredCurrency;

        // Validate inputs
        if (!customerPurchaseId || !ndc) {
          console.error("Missing customerPurchaseId or ndc");
          return null;
        }
        if (!this.validateRequest()) {
          console.error("Request validation failed");
          return null;
        }

        const module = {
              user_id: uid ?? "",
              anonymous_id: auth?.currentUser?.isAnonymous
                ? auth.currentUser.uid
                : null,
              action: "update_ndc",
              module_name: "insert_customer_purchase",
              ndc,
              purchase_id: customerPurchaseId,
            };
        return {
          modules: [
            this.salesJourneyIdentityService.applyIdentityEnvelope(module, {
              userId: auth?.currentUser?.isAnonymous ? null : (uid ?? null),
              // Omit customerId: resolve the actual SQL ID when available.
              anonymousId: auth?.currentUser?.isAnonymous ? auth.currentUser.uid : null,
              msn: user?.msn,
            }),
          ],
        };
      })
    );
  }



  // This method is used to get the request body for insert gdpr request
  insertGdprRequest(userID: string) {
    return {
      modules: [
        {
          module_name: "insert_gdpr_request",
          user_id: userID,
          calling_method: "DB",
          website_id: "33",
          gdpr_request: "Request information about my account",
        },
      ],
    };
  }

  public updateJackpotThreshold(updateTriggerData) {
    if (this.validateRequest()) {
      return {
        modules: [
          {
            module_name: "update_jackpot_trigger",
            user_id: updateTriggerData.userId,
            calling_method: "db",
            prosub_id: updateTriggerData.proSubId,
            offer_id: updateTriggerData.offerId,
            rollover_jackpot_action: "update_threshold",
            jackpot_trigger_value: updateTriggerData.updatedThreshold,
            sql_trigger_id: updateTriggerData.sqlId,
            requestid: uuidv4(),
            document: "/api_post_request/update_jackpot_trigger",
          },
        ],
      };
    }
  }
  public claimPrizeBoxRequest(gameId: number): Observable<any> {
    return this.authService.getUid$("RequestPaymentService").pipe(
      map((uid) => {
        const requestBody = {
          modules: [
            {
              module_name: "customer_purchase_prize_box",
              user_id: uid,
              game_id: gameId,
              calling_method: "db",
            },
          ],
        };
        return requestBody;
      }),
      catchError((err) => {
        return of(null);
      })
    );
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
